module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAHlBMVEXPFCv///8AJH3niZXzxcuAkr7w8vcQMoXbTl/bUGFq9DfUAAABL0lEQVR4Xu3XwUrDYBAE4BV6MLd/sEn1pkJ9juaRcunZR/CRhTBkyobRPzmIyj+3wH6F6SHZjdeUF+AhmLgDkAeefyNppJF+I7mWwLCJTCgBnDaQM2aCvpq8AbgEaCxJ4iNmgqGKTLMgYR9D1AMlSGgckbiECPsYouYiMo5c2YOEGRxRczVUH0PUI7oScZDpDVGPOKBENmsyi3cK/s/3t33WZKLgc1n1WZEzx/jbJOzDJHLbg4TGEwkSPTui5iRgHFF2k0b+flpaWn7wDdPII4dGQzRBsgjfRSaSMCRN6bNuv/vMcSFH9XDbBVNIniTMDpP6LMJvStmwR/flPpb7qIclqQ/Fd7tlJpUbLEQq92SRrnYbFxnrd36ScdNlsed+2XMl7bnFdlx8/+PgbaSRT4xOM9Y4WYzTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/United Kingdom.png
// module id = 615
// module chunks = 0